import { AssistContainer } from "../Assist/AssistContainer";
import { SidebarInset, SidebarProvider } from "../ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { AppTopBar } from "./AppTopBar";

type AppLayoutProps = React.PropsWithChildren<{
  fixedSidebar?: boolean;
}>;

export const AppLayout: React.FC<AppLayoutProps> = ({
  children,
  fixedSidebar,
}) => {
  return (
    <div className="align-items-stretch flex w-full flex-1 flex-row overflow-hidden">
      <SidebarProvider
        style={
          {
            "--sidebar-width": "14rem",
            "--sidebar-width-icon": "3rem",
            "--sidebar-width-mobile": "14rem",
          } as React.CSSProperties
        }
      >
        <AppSidebar fixed={fixedSidebar} />
        <SidebarInset>
          <div className="flex flex-1 flex-col overflow-auto">
            <AppTopBar />
            <div className="flex w-full flex-1 flex-col overflow-auto">
              {children}
            </div>
          </div>
        </SidebarInset>
      </SidebarProvider>

      <AssistContainer />
    </div>
  );
};
